import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import "./ConfirmDialog.scss";

interface ConfirmDialogProps {
  cancelButtonText: string;
  dialogHeader: string;
  okButtonText: string;
  onCancelClick: () => void;
  onClose: () => void;
  onOkClick: () => void;
  open: boolean;
  text: string;
}

const ConfirmDialog = ({
  cancelButtonText,
  dialogHeader,
  okButtonText,
  onCancelClick,
  onClose,
  onOkClick,
  open,
  text,
}: ConfirmDialogProps) => {
  return (
    <Dialog
    className="dialog"
      open={open}
      onClose={() => onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="spacer4"></div>
      <DialogContent>
        <>
          <div>
            <div className="confirmDialogHeader">
              <h3>{dialogHeader}</h3>
            </div>
          </div>
          <DialogContentText className="ConfirmDialogText">
            {text}
          </DialogContentText>
        </>
      </DialogContent>
      <DialogActions>
        <div className="confirmDialogActions">
          <Button
            className="confirmDialogCancel"
            variant="text"
            onClick={onCancelClick}
          >
            {cancelButtonText}
          </Button>
          <div className="spacer24"></div>
          <Button className="confirmDialogAccept" variant="contained" onClick={onOkClick}>
            {okButtonText}
          </Button>
        </div>
      </DialogActions>
      <div className="spacer12"></div>
    </Dialog>
  );
};

export default ConfirmDialog;
